import React, { FC, useCallback, useContext, useEffect, useState } from 'react';

import { navigate } from '@reach/router';

import { GlobalContext } from '../../../../store';
import { IGame } from '../../../../store/player/games/store';

import Button from '../../../../components/Button';
import { useRouteInfoState } from '../../../../components/RouteInfo/Context/RouteInfo.context';
import { useSortedGroupGames } from '../Utils/useSortedGroupEnrollments';
import Scorer from '../Components/Scorer';
import { useShotgunGameMetadata } from '../../ClubHome/CurrentEvent/Components/CurrentEventTeeTimeParings/useShotgunGameMetadata';

const SetOfficialScorer: FC = () => {
  const { actions, games, events } = useContext(GlobalContext);

  const { eventId, roundId } = useRouteInfoState();

  const [selectedScorer, setSelectedScorer] = useState(-1);
  const [moneyBallIsSelected, setMoneyBallIsSelected] = useState(false);
  const [currentGame, setCurrentGame] = useState<IGame>();

  const { isShotgun, startingHole } = useShotgunGameMetadata(currentGame);

  const [enrollments] = useSortedGroupGames(currentGame);

  const isScorer = useCallback((playerId: number) => playerId === selectedScorer, [selectedScorer]);

  const onSelectScorer = (playerId: number) => () => {
    setSelectedScorer(playerId);
  };

  const save = async () => {
    if (currentGame) {
      await actions.games.setScorer(currentGame.group.id, selectedScorer);
    }

    const eventStartingHole = isShotgun ? startingHole + 1 : 1;

    if (moneyBallIsSelected) {
      navigate(`/event-scores/${eventId}/round/${roundId}/set-moneyball-order`);
    } else {
      navigate(`/event-scores/${eventId}/round/${roundId}/hole/${eventStartingHole}/`);
    }
  };

  useEffect(() => {
    if (Object.values(games).length > 0 && roundId) {
      const newCurrentGame: IGame = Object.values(games).find(
        game => game.round.id === Number(roundId)
      );

      setCurrentGame(newCurrentGame);
    }
  }, [games]);

  useEffect(() => {
    if (currentGame) {
      setSelectedScorer(currentGame.group.scorer || -1);
    }
  }, [games, currentGame]);

  useEffect(() => {
    const event = events[Number(eventId)];
    if (!!event) {
      setMoneyBallIsSelected(event.formats.some(format => format.format.prefix.includes('money')));
    }
  }, [events, eventId]);

  return (
    <div className="score-route set-official-scorer">
      <h2>SELECT OFFICIAL SCORER</h2>

      <div className="scorers">
        {enrollments.map(enrollment => (
          <Scorer item={enrollment} key={`scorer-${enrollment.id}`}>
            <Button
              variant={isScorer(enrollment.user.id) ? 'contained' : 'outlined'}
              color="primary"
              className="select-scorer-button"
              onClick={onSelectScorer(enrollment.user.id)}
            >
              {isScorer(enrollment.user.id) ? 'SELECTED' : 'SELECT'}
            </Button>
          </Scorer>
        ))}
      </div>

      <Button
        disabled={selectedScorer < 0}
        variant="contained"
        color="primary"
        className="save-scorer-button"
        onClick={save}
      >
        SAVE
      </Button>
    </div>
  );
};

export default SetOfficialScorer;
